<template>
  <v-container fluid grid-list-sm>
    <v-layout v-if="!mobileScreen">
      <v-flex xs12 sm6>
        <v-img height="318px" :src="imgFirst">
        </v-img>
      </v-flex>

      <v-flex xs12 sm6>
        <v-img :src="imgSecond">
        </v-img>
      </v-flex>
    </v-layout>
    <ThirdImageView v-if="mobileScreen" :imgFirst="imgFirst"/>
    <ThirdImageView v-if="mobileScreen" :imgFirst="imgSecond"/>
  </v-container>
</template>
<script>
const MOBILE_WIDTH = 900
import ThirdImageView from './ThirdImageView'

export default {
    props: {
        imgFirst: String,
        imgSecond: String,
    },
    created() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    },
    data: () => {
      return {
        window: {
          width: 0
        },
        mobileScreen: false,
      }
    },
    components: {
      ThirdImageView,
    },
    methods: {
      handleResize() {
        this.window.width = window.innerWidth
        this.setImgCount()
      },
      setImgCount(){
        console.log('-setImgCount-')
        console.log(`width: ${this.window.width}`)
        if(this.window.width < MOBILE_WIDTH){
          console.log('-1-')
          this.mobileScreen = true
        }
        else{
          console.log('-2-')
          this.mobileScreen = false
        }
      },
    }
}
</script>

